(ns iris.posts.views.posts-logs-switch
  (:require
   [re-frame.core :as re-frame]
   [clojure.string :as string]
   [iris.subs :as subs]))

(defn posts-logs-switch []
  (let [{:keys [posts-href logs-href mirrored?]} @(re-frame/subscribe [::subs/mirror-hrefs])
        handler  @(re-frame/subscribe [::subs/handler])
        on-logs? (string/starts-with? (name (or handler :_)) "logs")]
    (when mirrored?
      [:div {:style {:text-align "center" :margin "15px 0"}}
       [:div.btn-group.btn-group-sm {:role "group"}
        [:a.btn {:href  posts-href
                 :class (if-not on-logs? "btn-primary" "btn-default")} "Posts"]
        [:a.btn {:href  logs-href
                 :class (if on-logs? "btn-primary" "btn-default")} "Logs"]]])))
